import React from 'react';

import $ from 'jquery';
import { version } from '../../package.json';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authActionCreators } from '../store/auth';

class Footer extends React.Component 
{
    constructor(props)
    {
        super(props);
    }
    
    render() 
    {
        return (
            <div className="footer">
                <div>{version}</div>
            </div>
        )
    }
}

function mapStateToProps(state)
{
    return {};
}
function mapDispatchToProps(dispatch)
{
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer);

